import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 15000 }
  }

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    if (this.timer) return

    this.timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  stopPolling() {
    if (!this.timer) return

    clearInterval(this.timer)
    this.timer = null
  }

  refresh() {
    if (document.hidden) return
    if (!this.element.reload) return

    this.element.reload()
  }
}
